// extracted by mini-css-extract-plugin
export default {"submitBtn":"TicketShower_submitBtn__9s45C"};